import InvitationsDashboard from '../common/InvitationsDashboard';

export default function AgencyInvitationsPage() {
  return <InvitationsDashboard role="AGENCY" title="Invitations" jobsLink="/agency/campaigns" />;
}
